
import 'aos/dist/aos.css';
import { useEffect, useState } from 'react';
import {
  Route, Switch
} from "react-router-dom";
import './App.css';
import About from './Components/About/About';
import OnlineResume from './Components/About/OnlineResume';
import Contacts from './Components/Contacts/Contacts';
import Education from './Components/Education/Education';
import Home from './Components/Home/Home';
import Dropdown from './Components/Navbar/Dropdown';
import Navbar from './Components/Navbar/Navbar';
import ProjectsData from './Components/Projects/ProjectsData';

function App() {

  const [isOpen,setIsOpen] = useState(false);
  const toggle =() =>{
    setIsOpen(!isOpen)
  }

  useEffect(() =>{
    const hideMenu = () =>{
      if (window.innerWidth > 768 && isOpen){
        setIsOpen(false)
      }
    }
    window.addEventListener('resize',hideMenu);
    return() =>{
      window.removeEventListener('resize', hideMenu)
    }
  })

  return (
    <div className="">
    <Navbar toggle={toggle}/>
    <Dropdown isOpen={isOpen} toggle={toggle}/>
    <Switch>
    <Route path="/" exact>
      <Home/>
    </Route>
    <Route path="/education" exact>
      <Education/>
    </Route>

    <Route path="/projects" exact>
      <ProjectsData/>
    </Route>
    <Route path="/contacts" exact>
      <Contacts/>
    </Route>
    <Route path="/about" exact>
      <About/>
    </Route>
    <Route path="/onlineresume" exact>
      <OnlineResume/>
    </Route>

    
    
    
    </Switch>
    <h1  className="text-xl font-bold text-center text-gray-500">Made with 💚 by Rian Islam</h1>
    </div>
  );
}

export default App;
